/*
 * A service for managing modal components
 * <p>
 *
 * @author Dzhenko Zlatev
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';


@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modalRef: any = {};
  private options: NgbModalOptions = {
    size: 'sm',
    backdrop: 'static'
  };

  constructor(private ngbModal: NgbModal) {
  }

  public open(name: string, component, modalOptions?: NgbModalOptions): NgbModalRef {
    try {
      const options: NgbModalOptions = Object.assign({}, this.options, modalOptions || {});
    } catch (error) {
      console.error(error);
    }
    this.modalRef[ name ] = this.ngbModal.open(component, modalOptions);
    return this.modalRef[ name ];
  }

  public close(name, result) {
    if (!this.modalRef[ name ]) {
      throw Error(`Unknown modal reference ${name}`);
    }
    this.modalRef[ name ].close(result);
    delete this.modalRef[ name ];
  }

  public dismiss(name, reason) {
    if (!this.modalRef[ name ]) {
      throw Error(`Unknown modal reference ${name}`);
    }
    this.modalRef[ name ].dismiss(reason);
    delete this.modalRef[ name ];
  }

  public getModalRef(name: string) {
    if (name && this.modalRef[ name ]) {
      return this.modalRef[ name ];
    }
    return false;
  }
}
